import { render, staticRenderFns } from "./BillPayment.vue?vue&type=template&id=4622a54e"
import script from "./BillPayment.vue?vue&type=script&lang=js"
export * from "./BillPayment.vue?vue&type=script&lang=js"
import style0 from "./BillPayment.vue?vue&type=style&index=0&id=4622a54e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports